'use client';

import { c as _c } from "react/compiler-runtime";
import { resolveProviderIcon } from '@/components/icons/provider-icons';
import type { ModelId } from '@/domains/pages/model-savings/types';
import { cn } from '@/utils/shad';

/** Infer a provider slug from model metadata when the backend provider is absent. */
export function resolveModelProviderSlug(modelId?: ModelId, modelName?: string, provider?: string | null): string | null {
  if (provider?.trim()) return provider.trim();
  const model = (modelName ?? '').trim().toLowerCase();
  const haystack = `${model} ${modelId ?? ''}`.toLowerCase();
  if (haystack.includes('claude') || haystack.includes('anthropic') || modelId === 'haiku' || modelId === 'sonnet' || modelId === 'opus' || modelId === 'flagship') {
    return 'anthropic';
  }
  if (haystack.includes('gpt') || haystack.includes('openai') || haystack.includes('chatgpt') || model === 'chat-latest' || /^o[134](?:-|$)/.test(model)) {
    return 'openai';
  }
  if (haystack.includes('gemini') || haystack.includes('veo') || haystack.includes('imagen')) {
    return 'google';
  }
  if (haystack.includes('granite') || haystack.includes('ibm') || haystack.includes('watson')) {
    return 'ibm';
  }
  if (haystack.includes('seedream') || haystack.includes('seedance') || haystack.includes('bytedance')) {
    return 'bytedance';
  }
  if (haystack.includes('firefly') || haystack.includes('adobe')) {
    return 'adobe';
  }
  return null;
}
type ModelProviderIconProps = {
  modelId?: ModelId;
  modelName?: string;
  provider?: string | null;
  className?: string;
};
export function ModelProviderIcon(t0) {
  const $ = _c(9);
  const {
    modelId,
    modelName,
    provider,
    className
  } = t0;
  let t1;
  if ($[0] !== modelId || $[1] !== modelName || $[2] !== provider) {
    const providerSlug = resolveModelProviderSlug(modelId, modelName, provider);
    t1 = resolveProviderIcon(providerSlug);
    $[0] = modelId;
    $[1] = modelName;
    $[2] = provider;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const Icon = t1;
  let t2;
  if ($[4] !== className) {
    t2 = cn("size-3 shrink-0", className);
    $[4] = className;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== Icon || $[7] !== t2) {
    t3 = <Icon className={t2} aria-hidden={true} />;
    $[6] = Icon;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}